import { Record } from 'immutable';
import { schema } from 'normalizr';

export const DailyInternationalPowerMeterReport = new Record({
  id: undefined,
  report_date: undefined,
  consumed_energy: undefined,
  site: undefined,
});

export const dailyInternationalPowerMeterReportSchema = new schema.Entity('dailyInternationalPowerMeterReports');

// for reading in nested models, object with { field: schema }
// dailyInternationalPowerMeterReportSchema.define({  });
